import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

import { AmountInputService } from './amount-input.service';

@Pipe({ name: 'Amount', standalone: false })
export class AmountCurrencyPipe implements PipeTransform {
  private DECIMAL_SEPARATOR: string;
  private THOUSANDS_SEPARATOR: string;
  private fractionSize: number;
  private padding: string;

  constructor(private amountInputService: AmountInputService) {}

  private getSeparators() {
    this.DECIMAL_SEPARATOR = this.amountInputService.getDecimalSeparator();
    this.THOUSANDS_SEPARATOR = this.amountInputService.getThousandsSeparator();
    this.fractionSize = this.amountInputService.getFractionSize();
    this.padding = _.repeat('0', this.fractionSize);
  }

  private replaceAll(search: string, separator: string, replacement: string) {
    return search.split(separator).join(replacement);
  }

  transform(value: string): string {
    this.getSeparators();

    let [integer, fraction = ''] = (value || '').toString().split(this.DECIMAL_SEPARATOR);

    fraction =
      this.fractionSize > 0
        ? this.DECIMAL_SEPARATOR +
          (fraction + this.padding).substring(0, this.fractionSize)
        : '';

    integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, this.THOUSANDS_SEPARATOR);

    return integer + fraction;
  }

  parse(value: string): string {
    this.getSeparators();

    let [integer, fraction = ''] = (value || '').split(this.DECIMAL_SEPARATOR);

    integer = this.replaceAll(integer, this.THOUSANDS_SEPARATOR, '');

    fraction =
      parseInt(fraction, 10) > 0 && this.fractionSize > 0
        ? this.DECIMAL_SEPARATOR +
          (fraction + this.padding).substring(0, this.fractionSize)
        : '';

    return integer + fraction;
  }
}
